import { Box, Paper, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useQuoteBasicList } from "../hooks/useQuoteBasicList";
import { QuoteBasicRow } from "./QuoteBasicRow";
import { colors, alphaVar } from "../../../../ui/colors";
import type { BasicRow } from "../types/basicQuote.types";

interface Props {
  onlyOneService?: boolean;
  onPayloadChange?: (payload: any) => void;
  initialRows?: BasicRow[];
}

export const JobBasicList = ({ onlyOneService, onPayloadChange, initialRows }: Props) => {
  const { rows, addRow, deleteRowLocalAndRedux, updateRowField, handleSaveAndLockRow, handleEnterEditMode, handleRemoveRowFromRedux } =
    useQuoteBasicList({ onlyOneService, onPayloadChange, initialRows });

  return (
    <Paper elevation={0} sx={{ borderRadius: 4, overflow: "hidden" }}>
      <Box sx={{ p: 1 }}>
        {rows.length === 0 && (
          <Box
            sx={{
              border: "2px dashed var(--fx-surface-borderstrong, #CBD5E1)",
              borderRadius: 3,
              p: 4,
              textAlign: "center",
              opacity: 0.7,
              my: 3,
            }}
          >
            <Typography fontWeight={700} fontSize={18} mb={1}>
              No services added
            </Typography>
            <Typography fontSize={14}>Click “Add Another Service” to begin</Typography>
          </Box>
        )}

        {rows.map((row, index) => (
          <QuoteBasicRow
            key={row.id}
            row={row}
            index={index}
            showHeader={index === 0}
            rowsCount={rows.length}
            onDeleteLocalAndRedux={deleteRowLocalAndRedux}
            onUpdateField={updateRowField}
            onSaveAndLock={handleSaveAndLockRow}
            onEnterEditMode={handleEnterEditMode}
            onlyOneService={onlyOneService}
            onRemoveFromRedux={handleRemoveRowFromRedux}
            canDelete={false}
          />
        ))}

        {!onlyOneService && (
          <Button
            fullWidth
            startIcon={<Add />}
            onClick={addRow}
            variant="outlined"
            sx={{
              py: 2,
              mt: 2,
              borderRadius: 2,
              borderStyle: "dashed",
              borderWidth: 2,
              color: colors.orange.base,
              borderColor: colors.gray[300],
              textTransform: "none",
              fontWeight: 600,
              fontSize: 15,
              "&:hover": {
                borderColor: colors.orange.base,
                backgroundColor: alphaVar(colors.orange.base, 0.05),
                color: colors.orange.base,
              },
            }}
          >
            Add Another Service
          </Button>
        )}
      </Box>
    </Paper>
  );
};
